/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ENVIRONMENT, EnvironmentService } from './environment.service';

@NgModule({
  imports: [CommonModule],
})
export class EnvironmentModule {
  static forRoot(environment: any): ModuleWithProviders<EnvironmentModule> {
    return {
      ngModule: EnvironmentModule,
      providers: [{ provide: ENVIRONMENT, useValue: environment }, EnvironmentService],
    };
  }
}
